import type { Vacancy } from 'clients/AutoCompleteClient/types';
import type { JobSummaryViewModel } from '@/features/job-improved-selection';

export const jobSummaryToVacancy = (summary: JobSummaryViewModel): Vacancy => {
  const base = {
    db_id: summary.dbId,
    job_title: summary.jobTitle,
    origin_job_title: summary.originJobTitle ?? undefined,
    quality_percent: summary.qualityPercent,
    is_improved: summary.isImproved,
    created_at: summary.createdAt,
    updated_at: summary.updatedAt,
    name: summary.name,
    job_ats_id: summary.jobAtsId,
    job_indeed_id: summary.jobIndeedId,
    job_campaign_id: summary.jobCampaignId,
  };

  switch (summary.type) {
    case 'INDEED':
      return {
        ...base,
        type: 'INDEED',
        job_indeed_id: summary.jobIndeedId ?? '',
        value: summary.jobIndeedId ?? summary.name,
      } as Vacancy;
    case 'ATS':
    case 'ATS_RAW':
      return {
        ...base,
        type: summary.type,
        job_ats_id: summary.jobAtsId,
        value: summary.jobAtsId || String(summary.dbId ?? summary.name),
      } as Vacancy;
    case 'CAMPAIGN':
      return {
        ...base,
        type: 'CAMPAIGN',
        job_campaign_id: summary.jobCampaignId ?? '',
        value: summary.jobCampaignId ?? String(summary.dbId ?? summary.name),
      } as Vacancy;
    case 'CREATED':
    default:
      return {
        ...base,
        type: 'CREATED',
        value: String(summary.dbId ?? summary.jobAtsId ?? summary.name),
      } as Vacancy;
  }
};
